import { render } from "./admin-spare-part-overview.vue?vue&type=template&id=04b02cad&ts=true"
import script from "./admin-spare-part-overview.vue?vue&type=script&lang=ts"
export * from "./admin-spare-part-overview.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__